import React from 'react'

export const SectionLoadingPlaceholder = () => {
  return <div className='section-loading-placeholder' />
}
